module.exports = __webpack_public_path__ + "static/media/chelshospital.7dbe757c.png";